import {
  shareTextNative,
  shareImageWithMob,
  shareWithImage,
  shareWithMob,
} from '../bridges/android'
import {
  shareImageWithMobInIos,
  shareTextNativeInIos,
  shareWithImageInIos,
  shareWithMobInIos,
} from '../bridges/iOS'
import { WHATS_APP_URL } from '../constants/appUrls'
import searchBuilder from './queryBuilder'
import { isIos } from './utility'

export const shareWithReqularWhatsApp = (
  finalMsg,
  phone,
  callback = () => {}
) => {
  const shareObj = {
    text: finalMsg,
  }

  if (phone) {
    shareObj.phone = phone
  }
  const queryString = searchBuilder(shareObj)
  const url = encodeURI(`${WHATS_APP_URL}${queryString}`)
  callback(finalMsg, phone)
  // this to start timer for whatsAppBtn and disable the btn for 60 sec.
  window.open(url)
}

export const sharingViaWhatsApp = ({
  text,
  mobile,
  img,
  callback = () => {},
}) => {
  const fallback = () => shareWithReqularWhatsApp(text, mobile, callback)

  if (isIos()) {
    // Handle ios case
    switch (true) {
      case img && mobile:
        return shareImageWithMobInIos(
          {
            imgUrl: img,
            message: text,
            phoneNumber: mobile,
          },
          fallback
        )
      case img && !mobile:
        return shareWithImageInIos(
          {
            imgUrl: img,
            message: text,
            phoneNumber: mobile,
          },
          fallback
        )
      case !img && mobile:
        return shareWithMobInIos(
          {
            imgUrl: img,
            message: text,
            phoneNumber: mobile,
          },
          fallback
        )
      case !img && !mobile:
        return shareTextNativeInIos(
          {
            imgUrl: img,
            message: text,
            phoneNumber: mobile,
          },
          fallback
        )
      default:
        return shareTextNativeInIos(
          {
            imgUrl: img,
            message: text,
            phoneNumber: mobile,
          },
          fallback
        )
    }
  }

  // Handle android & web case
  switch (true) {
    case img && mobile:
      return shareImageWithMob(text, '', text, mobile, fallback)
    case img && !mobile:
      return shareWithImage(img, '', text, fallback)
    case !img && mobile:
      return shareWithMob('', text, mobile, fallback)
    case !img && !mobile:
      return shareTextNative('', text, fallback)
    default:
      return shareTextNative('', text, fallback)
  }
}
